const api = {
  Login: '/sys/login',
  Logout: '/sys/logout',
  ForgePassword: '/auth/forge-password',
  Register: '/auth/register',
  SendSms: '/account/sms',
  // get my info
  UserInfo: '/user/info',
  /**
   * 获取发布公告接口
   * @params: msgType === 11 集采公告; msgType === 12 中标公告； msgType === 13 其他公告
   * methods: get
   */
  edtPublishMsg: '/web/publishMsg/noticeList',
  // 获取采购信息列表
  edtTenderMsg: '/ueditor/edtTenderMsg/listAll',
   // 获取网页标讯列表
  webTenderList: '/web/publishMsg/webTenderList',
}
export default api


// WEBPACK FOOTER //
// ./src/assets/js/api/index.js